import { ConfirmChildDemographicSaveComponent } from './confirm-child-demographic-save/confirm-child-demographic-save.component';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { EditChildDemographicIdentifiersComponent } from './edit-child-demographic-identifiers/edit-child-demographic-identifiers.component';
import { EditChildDemographicParentsComponent } from './edit-child-demographic-parents/edit-child-demographic-parents.component';
import { EditChildDemographicGeneralComponent } from './edit-child-demographic-general/edit-child-demographic-general.component';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { EditChildDemographicTerminationComponent } from './edit-child-demographic-termination/edit-child-demographic-termination.component';
import { timeout } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EditChildModalComponent } from '../edit-child-modal-btn/edit-child-modal/edit-child-modal.component';

@Component({
    selector: 'edit-child-demographic',
    templateUrl: './edit-child-demographic.component.html',
    styleUrls: ['./edit-child-demographic.component.scss']
})
export class EditChildDemographicComponent implements OnInit {
    @Input() studentId!: number;
    @Input() editing: boolean;
    @Output() editingChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    msdNumber: string;

    @ViewChild('editChildDemographicGeneral') EditChildDemographicGeneralComponent: EditChildDemographicGeneralComponent;
    @ViewChild('editChildDemographicTermination') EditChildDemographicTerminationComponent: EditChildDemographicTerminationComponent;
    @ViewChild('editChildDemographicParents') EditChildDemographicParentsComponent: EditChildDemographicParentsComponent;
    @ViewChild('editChildDemographicIdentifiers') EditChildDemographicIdentifiersComponent: EditChildDemographicIdentifiersComponent;

    promises: Array<any> = [];
    isSaving: boolean = false;
    messages: MsgModel[] = [];

    constructor(private dialog: MatDialog) {}

    ngOnInit(): void {}

    submit(): Promise<any> {
        if (this.editing) {
            this.isSaving = true;
            this.promises = [];
            this.messages = [];

            this.promises.push(this.EditChildDemographicGeneralComponent.submit());
            this.promises.push(this.EditChildDemographicTerminationComponent.submit());
            this.promises.push(this.EditChildDemographicParentsComponent.submit());
            this.promises.push(this.EditChildDemographicIdentifiersComponent.submit());

            return Promise.all(this.promises).then(
                (res) => {
                    this.isSaving = false;
                    this.messages = res;

                    this.editing = false;
                    this.editingChange.emit(this.editing);

                    this.clearMessagesTimeout(5000);
                },
                (err) => {
                    this.isSaving = false;
                    this.messages.push(err);

                    this.clearMessagesTimeout(5000);
                }
            );
        } else {
            return new Promise((resolve, reject) => {
                reject({});
            });
        }
    }
    reject(arg0: {}) {
        throw new Error('Method not implemented.');
    }

    clearMessagesTimeout(ms: number) {
        setTimeout(() => {
            this.messages = [];
        }, ms);
    }

    // Dialog Modal
    confirmSave() {
        if (this.editing) {
            let payload: any = {};
            payload.CATEGORIES = [];

            payload.CATEGORIES.push({
                CATEGORY: 'Student Demographics',
                CHANGES: this.EditChildDemographicGeneralComponent.getChanges()
            });
            payload.CATEGORIES.push({
                CATEGORY: 'Student Termination',
                CHANGES: this.EditChildDemographicTerminationComponent.getChanges()
            });
            payload.CATEGORIES.push({
                CATEGORY: 'Parents/Guardians',
                CHANGES: this.EditChildDemographicParentsComponent.getChanges()
            });
            payload.CATEGORIES.push({
                CATEGORY: 'Student Identifiers',
                CHANGES: this.EditChildDemographicIdentifiersComponent.getChanges()
            });

            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            dialogConfig.data = payload;
            dialogConfig.minWidth = '60vw';
            const dialogRef = this.dialog.open(ConfirmChildDemographicSaveComponent, dialogConfig);

            dialogRef.afterClosed().subscribe((res: any) => {
                if (res && res.confirmed) {
                    this.submit();
                } else {
                    // Closed
                }
            });
        }
    }
}
